
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
     apiKey: "AIzaSyC74WfcBfeemhbawXdcmH9tUso-_oQoAUQ",
  authDomain: "lodge-greenhouse.firebaseapp.com",
  projectId: "lodge-greenhouse",
  storageBucket: "lodge-greenhouse.firebasestorage.app",
  messagingSenderId: "234586646072",
  appId: "1:234586646072:web:2c14e955978110a7f1e8cd",
  measurementId: "G-7T3ZD8L122"

};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;